import React from "react";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

import DataTable from "../../../common/DataTable";
import ColumnHeader from "../../../common/ColumnHeader";
import { Chip } from "@mui/material";
import { getChipColor } from "../../../../constants/value";
import { dateSortComparator } from "../../../../utils/date";

const TmobilejChangeNumberList = ({
  data,
  loading,
  meta,
  client,
  handleColumnClick,
  disableRowClick,
}) => {
  const nav = useNavigate();

  const handleRowClick = (e) => {
    nav(`/tmobilej/change_number/${e.row.id}`);
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 1 },
    {
      field: "iccid",
      headerName: "ICCID",
      minWidth: 180,
      flex: 3,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"ICCID"}
            handleClick={() => handleColumnClick("iccid")}
          />
        ) : (
          "ICCID"
        ),
    },
    {
      field: "old_msisdn",
      headerName: "MSISDN",
      minWidth: 100,
      flex: 2,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Old MSISDN"}
            handleClick={() => handleColumnClick("old_msisdn")}
          />
        ) : (
          "Old MSISDN"
        ),
    },
    {
      field: "new_msisdn",
      headerName: "MSISDN",
      minWidth: 100,
      flex: 2,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"New MSISDN"}
            handleClick={() => handleColumnClick("new_msisdn")}
          />
        ) : (
          "New MSISDN"
        ),
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 120,
      flex: 2,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"Status"}
            handleClick={() => handleColumnClick("status")}
            copyText="Status"
          />
        ) : (
          "Status"
        ),
      renderCell: (params) => (
        <Chip
          label={params.row.status}
          size="small"
          color={getChipColor(params.row.status)}
        />
      ),
    },
    {
      field: "created_at",
      headerName: "Created At",
      minWidth: 200,
      filterable: false,
      flex: 3,
      valueGetter: (params) => params.row.created_at || null,
      valueFormatter: (params) =>
        params.value &&
        `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
    {
      field: "last_updated",
      headerName: "Last Updated",
      minWidth: 200,
      filterable: false,
      flex: 3,
      valueGetter: (params) => params.row.last_updated || null,
      valueFormatter: (params) =>
        params.value &&
        `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
  ];

  return (
    <DataTable
      disableColumnFilter
      data={data}
      columns={columns}
      loading={loading}
      metaData={meta}
      client={client}
      handleRowClick={disableRowClick ? null : handleRowClick}
    />
  );
};

export default TmobilejChangeNumberList;
